import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { SpeakerIcon } from '../assets/SpeakerIcon';
import { AudioIconProgress } from '../components/AudioIconProgress';
import { greyActiveColor, grayBackGroundColor, mediumBlue, white } from '../styles/colors';
import { withPlayerUpdater } from '../utils/withPlayerUpdater';

var SpeakerButtonDiv = styled.div(function (props) {
  var style = {
    display: 'inline-block',
    verticalAlign: 'top',
    cursor: 'pointer'
  };
  if (props.disabled) {
    style.pointerEvents = 'none';
    style.opacity = 0.4;
  }
  return style;
});

var SpeakerIconDiv = styled.div(function (props) {
  var style = {
    width: props.iconSize,
    height: props.iconSize,
    cursor: 'pointer'
  };
  return style;
});

var SpeakerButtonTextDisp = styled.div(function (props) {
  var style = {
    color: props.textColor,
    fontSize: 16,
    lineHeight: '22px',
    whiteSpace: 'nowrap',
    textAlign: 'center',
    marginTop: 4
  };
  return style;
});

//***************************************************************************************

var SpeakerAndProgressButtonBase = function (_PureComponent) {
  _inherits(SpeakerAndProgressButtonBase, _PureComponent);

  function SpeakerAndProgressButtonBase() {
    _classCallCheck(this, SpeakerAndProgressButtonBase);

    return _possibleConstructorReturn(this, _PureComponent.apply(this, arguments));
  }

  SpeakerAndProgressButtonBase.prototype.render = function render() {
    var circleColor = 'none';
    var iconColor = mediumBlue;
    if (this.props.fill) {
      circleColor = this.props.fillColor;
    }

    if (this.props.darkTheme && !this.props.isMediaPlaying) {
      iconColor = white;
      circleColor = mediumBlue;
    }

    if (this.props.isMediaPlaying) {
      circleColor = grayBackGroundColor;
    }

    var textDisp = void 0;
    if (this.props.text) {
      textDisp = React.createElement(
        SpeakerButtonTextDisp,
        { textColor: iconColor },
        this.props.text
      );
    }

    var progressDisp = void 0;
    if (this.props.isMediaPlaying && this.props.mediaPosition > 0 && this.props.mediaPosition < this.props.mediaDuration) {
      progressDisp = React.createElement(AudioIconProgress, { circleSize: this.props.buttonSize, progress: this.props.mediaPlayer.progress });
    }

    return React.createElement(
      SpeakerButtonDiv,
      {
        'data-qa': 'audio_' + (this.props.isMediaPlaying ? 'playing' : 'paused'),
        iconSize: this.props.buttonSize,
        onClick: this.props.onClick,
        disabled: this.props.disabled
      },
      React.createElement(
        SpeakerIconDiv,
        { 'data-qa': 'ListenButton', iconSize: this.props.buttonSize },
        progressDisp,
        React.createElement(SpeakerIcon, { circleFill: circleColor, iconFill: iconColor })
      ),
      textDisp
    );
  };

  return SpeakerAndProgressButtonBase;
}(PureComponent);

SpeakerAndProgressButtonBase.propTypes = {
  mediaPlayer: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  buttonSize: PropTypes.number.isRequired,
  fill: PropTypes.bool,
  fillColor: PropTypes.string,
  darkTheme: PropTypes.bool
};
SpeakerAndProgressButtonBase.defaultProps = {
  fill: false,
  fillColor: greyActiveColor,
  darkTheme: false
};

export var SpeakerAndProgressButton = withPlayerUpdater(SpeakerAndProgressButtonBase);